import React from 'react';
import RInputMask from 'react-number-format';
import { Controller } from 'react-hook-form';
import cs from 'classnames';
import styles from './input.module.scss';

export const InputMask = props => {
  const {
    inputRef,
    label,
    id,
    touched,
    error,
    name,
    mask,
    format,
    maskChar,
    onChange,
    control,
    type,
    disabled,
    iconRight,
    ...other
  } = props;

  return (
    <div className={styles.root}>
      <label htmlFor={id} className="block">
        {label}
      </label>
      <Controller
        render={({ field: ControllerField }) => {
          const {
            onBlur: ControllerOnBlur,
            onChange: ControllerOnChange,
            value: ControllerValue,
            name: ControllerName,
            ...ControllerRef
          } = ControllerField;
          return (
            <div className="relative flex" {...ControllerRef} tabIndex={'0'}>
              <RInputMask
                value={ControllerValue}
                onBlur={ControllerOnBlur}
                autoComplete={type}
                className={cs(
                  'border focus:outline-none rounded mt-2 w-full p-2',
                  {
                    'border-brandred': error,
                  }
                )}
                data-testid={name}
                disabled={disabled}
                name={name}
                getInputRef={inputRef}
                format={format}
                mask={mask}
                maskchar={maskChar}
                onChange={event => {
                  ControllerOnChange(event);
                  if (onChange) onChange(event);
                }}
                {...other}
              />
              <div className="absolute right-0 bottom-0 mr-2 mb-2">
                {iconRight}
              </div>
            </div>
          );
        }}
        name={name}
        control={control}
        {...other}
      />
      {error ? (
        <span
          data-testid={'error.' + name}
          className="text-brandred -mt-2 text-sm"
        >
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default InputMask;
